import { render, staticRenderFns } from "./TransactionsDesktop.vue?vue&type=template&id=6af2ca8c&scoped=true"
import script from "./TransactionsDesktop.vue?vue&type=script&lang=js"
export * from "./TransactionsDesktop.vue?vue&type=script&lang=js"
import style0 from "./TransactionsDesktop.vue?vue&type=style&index=0&id=6af2ca8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af2ca8c",
  null
  
)

export default component.exports